import api from '../utils/request'

export default {
  // 设备台账列表（条件留空则查全部）
  list(params) {
    return api.get('/equipment/', { params })
  },
  // 新增设备（含文件上传，FormData）
  create(data) {
    return api.post('/equipment/', data)
  },
  // 设备台数统计（主页大屏用）：只取分页响应里的 count 字段，不拉全量数据。
  // 用法：getEquipmentCount() 取总台数；getEquipmentCount({ name: '监护仪' }) 取某一类设备台数。
  // 默认补 page=1&page_size=1，调用方传入的 params 优先级更高（同名键覆盖默认值）。
  getEquipmentCount(params) {
    return api.get('/equipment/', {
      params: Object.assign({ page: 1, page_size: 1 }, params || {}),
    })
  },
  // 设备详情
  detail(id) {
    return api.get(`/equipment/${id}/`)
  },
  // 编辑设备（含可选文件替换，FormData）
  update(id, data) {
    return api.put(`/equipment/${id}/`, data)
  },
  // 删除设备
  delete(id) {
    return api.delete(`/equipment/${id}/`)
  },
  // 导出勾选设备的资质/二维码/照片为 ZIP（blob 下载）；types: qualification/qrcode/photo
  exportFiles(payload) {
    return api.post('/equipment/export-files/', payload, {
      responseType: 'blob',
      timeout: 120000,
    })
  },
  // 导出二维码标签图：后端已把「二维码 + 科室/型号/设备编号/导出时间」合成成一张图，
  // 解压后直接打印即可，无需再用标签软件排版。ids 为空时后端按当前筛选条件导出。
  exportQrcodeLabels(payload) {
    return api.post('/equipment/export-qrcode-labels/', payload, {
      responseType: 'blob',
      timeout: 180000,
    })
  },
  // 导出标签打印数据（Excel）：科室/型号/设备编号/导出时间，
  // 供标签打印机自带的设计软件做「变量批量打印」，比打印位图清晰。
  exportLabelData(payload) {
    return api.post('/equipment/export-label-data/', payload, {
      responseType: 'blob',
      timeout: 120000,
    })
  },
  // 铭牌照片 OCR 识别（FormData: image_file），返回可回填字段 data
  nameplateExtract(formData) {
    return api.post('/equipment/nameplate-extract/', formData, {
      timeout: 120000,
    })
  },
}
